import { NSARouterMakerResult } from "namirasoft-account-react";
import { RuleRow } from "namirasoft-bill-watch";
import { SortItem } from "namirasoft-core";
import { NamirasoftMap } from "namirasoft-site-map";
import { IBaseComponentProps, NSBoxEntity } from "namirasoft-site-react";
import { Component, createRef } from "react";
import { BillWatchProps } from "../BillWatchProps";

export interface RuleLineProps extends IBaseComponentProps, NSARouterMakerResult, BillWatchProps
{
	index: number;
	deletable: boolean;
	fullWidth?: boolean;
	onDelete: () => void;
	onChanged?: (value: any) => void;
}

export default class RuleLine extends Component<RuleLineProps>
{
	static IS_DIRTY(value: any): boolean
	{
		if (value)
			return true;
		return false;
	}

	private NSBoxEntity_Rule = createRef<NSBoxEntity<RuleRow>>();

	constructor(props: RuleLineProps)
	{
		super(props);
		this.getValue = this.getValue.bind(this);
		this.isDirty = this.isDirty.bind(this);
		this.onChanged = this.onChanged.bind(this);
	}

	getValue(checkError?: boolean): string
	{
		return this.NSBoxEntity_Rule.current?.getValueOne(checkError) ?? "";
	}

	setValue(value: string)
	{
		this.NSBoxEntity_Rule.current?.setValue(value);
	}

	isDirty(): boolean
	{
		return RuleLine.IS_DIRTY(this.getValue());
	}

	private onChanged()
	{
		if (this.props.onChanged)
			this.props.onChanged(this.getValue());
	}

	override render()
	{
		let namirasoft = new NamirasoftMap(this.props.account.token_manager, console.error);

		return (
			<NSBoxEntity<RuleRow>
				ref={this.NSBoxEntity_Rule}
				{...this.props}
				title={`Rule ${this.props.index + 1}`}
				info={{
					link: "https://namirasoft.com/bill-watch/console-guide/rule/"
				}}
				required={false}
				multiple={false}
				table={namirasoft.bill_watch.tables.rule}
				getValue={item => item.id}
				getTitle={item =>
				{
					return item.name + (item.user_id == null ? " (Global)" : "");
				}}
				getSort={() =>
				{
					return new SortItem(namirasoft.bill_watch.tables.rule, namirasoft.bill_watch.tables.rule.columns.name, true);
				}}
				onChanged={this.onChanged}
				style={{ ...this.props.style, width: "100%" }}
				menu={{
					builtin: {
						delete: {
							enabled: this.props.deletable,
							onDelete: () => { this.props.onDelete(); }
						}
					},
					items: []
				}}
			/>
		);
	}
}